
import { Component, Vue } from 'vue-property-decorator';


import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "./components/UnderlineForm.vue"
import moment from 'moment';
import { stepInfoType } from '@/types/Application';

@Component({
    components:{
        UnderlineForm
    }
})

export default class FormP5 extends Vue { 
    
    @applicationState.State
    public steps!: stepInfoType[];

    @applicationState.State
    public deceasedName!: string;

    @applicationState.State
    public deceasedAliases!: string[];

    @applicationState.State
    public relatedPeopleInfo!: any;

    @applicationState.Action
    public UpdateGotoPrevStepPage!: () => void

    @applicationState.Action
    public UpdateGotoNextStepPage!: () => void

    dataIsReady = false;
    multipleApplicant=false
    applicantList = []
    applicantCourtHouse = '';
    deceased;
    serviceContact; 
    
    mounted(){
        this.dataIsReady = false;
        this.getRepGrantResultData();
        this.getApplicantsInfo();
        this.getDeceasedInfo();
        this.dataIsReady = true;
    }

    public getDeceasedInfo() {
        
        if (this.steps[0] && this.steps[0].result && this.steps[0].result["deceasedInfoSurvey"] && this.steps[0].result["deceasedInfoSurvey"].data) {
            const deceasedInfoSurvey = this.steps[0].result["deceasedInfoSurvey"].data;
            this.deceased = {
                fullName: Vue.filter('getFullName')(this.deceasedName), 
                first:this.deceasedName['first'], 
                middle:this.deceasedName['middle'],
                last:this.deceasedName['last'],
                address: deceasedInfoSurvey.deceasedAddress, 
                DOD: Vue.filter('beautify-full-date')(deceasedInfoSurvey.deceasedDateOfDeath)
            }           
        }      

    }

    public getApplicantsInfo() {

        if (this.multipleApplicant){
            this.changeApplicantList();
        } else {
            this.applicantList = [];            

            if (this.steps[3] && this.steps[3].result && this.steps[3].result["applicantInfoSurvey"] && this.steps[3].result["applicantInfoSurvey"].data) {
                const applicantInfoSurvey = this.steps[3].result["applicantInfoSurvey"].data;
                if (applicantInfoSurvey.applicantName.length > 0) {
                    for (const applicant of applicantInfoSurvey.applicantName) {
                        const index = applicant.charAt(14)

                        const applicantSurvey = this.relatedPeopleInfo[index];

                        const applicantInfo = {
                            fullName:Vue.filter('getFullName')(applicantSurvey.name),
                            first:applicantSurvey.name.first, 
                            middle:applicantSurvey.name.middle,
                            last:applicantSurvey.name.last                                                          
                        }

                        if (applicantInfoSurvey["applicantOccupation[" + index + "]"]) {
                            applicantInfo["occupation"] = (applicantInfoSurvey["applicantOccupation[" + index + "]"]);
                        }
                        
                        if (applicantInfoSurvey["applicantMailingAddressIsOrdinary[" + index + "]"] && (applicantInfoSurvey["applicantMailingAddressIsOrdinary[" + index + "]"] == 'y')) {
                            
                            if (applicantInfoSurvey["applicantMailingAddress[" + index + "]"]) {
                                const addressInfo = applicantInfoSurvey["applicantMailingAddress[" + index + "]"];                               
                                applicantInfo["address"] = addressInfo;
                            }
                           
                        } else if (applicantInfoSurvey["applicantMailingAddressIsOrdinary[" + index + "]"] && (applicantInfoSurvey["applicantMailingAddressIsOrdinary[" + index + "]"] == 'n')) {
                            
                            if (applicantInfoSurvey["applicantOrdinaryAddress[" + index + "]"]) {
                                const addressInfo = applicantInfoSurvey["applicantOrdinaryAddress[" + index + "]"];                                
                                applicantInfo["address"] = addressInfo;
                            }
                           
                        } else {
                            applicantInfo["address"] = '';
                        }
                        // console.log(applicantInfo)
                        this.applicantList.push(applicantInfo);                        
                    }
                }                
               //TODO: temporarily commenting out until we get the types setup
                // this.applicantCourtHouse = applicantInfoSurvey.applicantCourthouse;
                // this.serviceContact = {
                //     address:applicantInfoSurvey.applicantServiceAddress.street + ', ' 
                //         + applicantInfoSurvey.applicantServiceAddress.city +', '
                //         + applicantInfoSurvey.applicantServiceAddress.state +', '
                //         + applicantInfoSurvey.applicantServiceAddress.country +', ' 
                //         + applicantInfoSurvey.applicantServiceAddress.postcode,
                //     phone:applicantInfoSurvey.applicantServiceEmail,                    
                //     email:applicantInfoSurvey.applicantServicePhone
                // }
            }
        }

    }
    
    public changeApplicantList(){
        this.applicantList=[]
        if(this.multipleApplicant){
            this.applicantList.push(
                {fullName:"Its first Son",first:"Its", middle:"first",last:"Son", address:"Victoria, BC, Canada", notIndividual:"", individual:"yes", sameMail:"", differentMail:"yes", differentAddress:"New York, USA", occupation:"worker", city:"Victoria", state:"BC", country:"Canada", section130:"(b)" },
                {fullName:"Its first Daughter",first:"Its", middle:"first",last:"Daughter", address:"Victoria, BC, Canada", notIndividual:"", individual:"yes", sameMail:"yes", differentMail:"", differentAddress:"", occupation:"work", city:"Seattle", state:"WA", country:"USA", section130:"(a)"  },
                {fullName:"Its second Son",first:"Its", middle:"second",last:"Son", address:"Vancouver, BC, Canada", notIndividual:"", individual:"yes", sameMail:"yes", differentMail:"", differentAddress:"", lawyer:"Its good lawyer", occupation:"working" , city:"Seattle", state:"WA", country:"USA", section130:"(c)" },
                {fullName:"Its second Daughter",first:"Its", middle:"second",last:"Daughter", address:"Vancouver, BC, Canada", notIndividual:"", individual:"yes", sameMail:"yes", differentMail:"", differentAddress:"", occupation:"worker" , city:"Vancouver", state:"BC", country:"Canada", section130:"(d)" }, 
                {fullName:"Its third Son",first:"Its", middle:"third",last:"Son", address:"Victoria, BC, Canada", notIndividual:"", individual:"yes", sameMail:"", differentMail:"yes", differentAddress:"New York, USA", occupation:"work", city:"Seattle", state:"WA", country:"USA" , section130:"(d)" },
                {fullName:"Its third Daughter",first:"Its", middle:"third",last:"Daughter", address:"Victoria, BC, Canada", notIndividual:"", individual:"yes", sameMail:"yes", differentMail:"", differentAddress:"", occupation:"worker", city:"Victoria", state:"BC", country:"Canada", section130:"(e)"  },
                {fullName:"Its fourth Son",first:"Its", middle:"fourth",last:"Son", address:"Vancouver, BC, Canada", notIndividual:"", individual:"yes", sameMail:"yes", differentMail:"", differentAddress:"", lawyer:"Its good lawyer", occupation:"work" , city:"Victoria", state:"BC", country:"Canada", section130:"(f)" },
                {fullName:"Its fourth Daughter",first:"Its", middle:"fourth",last:"Daughter", address:"Vancouver, BC, Canada", notIndividual:"", individual:"yes", sameMail:"yes", differentMail:"", differentAddress:"", occupation:"working", city:"Seattle", state:"WA", country:"USA" , section130:"(f)" }, 
                {fullName:"Its fifth Son",first:"Its", middle:"fifth",last:"Son", address:"Vancouver, BC, Canada", notIndividual:"", individual:"yes", sameMail:"", differentMail:"yes", differentAddress:"New York, USA", occupation:"worker", city:"Seattle", state:"WA", country:"USA" , section130:"(f)" },
                {fullName:"Its fifth Daughter",first:"Its", middle:"fifth",last:"Daughter", address:"Vancouver, BC, Canada", notIndividual:"", individual:"yes", sameMail:"yes", differentMail:"", differentAddress:"", occupation:"work", city:"Victoria", state:"BC", country:"Canada", section130:"(a)"  },
            )
        }else{
            this.getApplicantsInfo();
        }
    }

    public getSignatureMargin(){

        let margin = Number(10/this.applicantList.length);
        if(margin<1.0) margin = 1;
        return margin+'rem'
    }

    public getAllApplicants(len: number){
        let result="";
        for(const name of this.applicantList)
            result += name.fullName+', ';
        result = result.slice(0,-2);
        if(result.length>len)
            result = result.slice(0,len) +"..."
        return result
    }

    public onPrint() {
        
        const el= document.getElementById("print");
        console.log(el)
        const applicationId = this.$store.state.Application.id;
        const bottomLeftText = `"Generated by “Apply to Represent Someone Who Died” on `+moment().format("MMMM D, YYYY")+`.";`;
        const bottomRightText = `"P5"`
        const url = '/survey-print/'+applicationId+'/?name=representation-grant'
        const body = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText );
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  
        console.log(body)
        this.$http.post(url,body, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = "FormP5.pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);            
        },err => {
            console.error(err);
        
        });
    }

 
    public getRepGrantResultData() {  
        
        let result = this.$store.state.Application.steps[0].result; 
        for(let i=1;i<9; i++){
            const stepResults = this.$store.state.Application.steps[i].result
            for(const stepResult in stepResults){
                //console.log(stepResults[stepResult])
                //console.log(stepResults[stepResult].data)
                result[stepResult]=stepResults[stepResult].data; 
            }
        }
        const protectedPartyName = {protectedPartyName: this.$store.state.Application.protectedPartyName}
        Object.assign(result, result, protectedPartyName);
        
        const applicationLocation = this.$store.state.Application.applicationLocation;
        const userLocation = this.$store.state.Common.userLocation;
        //console.log(applicationLocation)
        //console.log(userLocation)
        if(applicationLocation)
            Object.assign(result, result,{applicationLocation: applicationLocation}); 
        else
            Object.assign(result, result,{applicationLocation: userLocation});
        console.log(result)
        return result;
    }

}
